module.exports = __webpack_public_path__ + "static/1316272527.526adf86.jpg";